import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

/**
 * 获取项目列表
 * */
export function getProjectInfoPage(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayProjectInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}
/**
 * 生成二维码
 */
export function getQRCode(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayProjectInfo/gl/v1.0.0/getQRCode`,
        method: 'post',
        data
    })
}
/**
 * 获取项目详情
 * */
export function getProjectInfoOneById(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayProjectInfo/gl/v1.0.0/detail`,
        method: 'post',
        data
    })
}
/**
 * 添加项目
 * */
export function getComplaintAddOREdit(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayProjectInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}
/**
 * 编辑项目
 * */
export function getComplaintEditOREdit(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayProjectInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

